<router-outlet>
  <app-navbar [fixedHeader]="true" [footerLogo]="true"></app-navbar>
  <ng-container *ngIf="loaded; else spinner">
    <section *ngIf="options.length > 0" class="mx-3">
      <app-product-item *ngFor="let option of options; trackBy: trackByFn" [languages]="languages" [option]="option">
      </app-product-item>
    </section>
  </ng-container>
  <app-footer *ngIf="loaded" [footerLogo]="true"></app-footer>
  <ng-template #spinner>
    <div class="spinner-container">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </ng-template>
</router-outlet>
